<template>
  <div class="ov">
    <CoolLightBox
      :items="items"
      :index="index"
      @close="index = null">
    </CoolLightBox>
    <ul class="items chang">
      <li v-for="(image, imageIndex) in product" ><a @click="index = imageIndex"><img :src="image.big_pic" :alt="image.title"></a></li>
    </ul>
  </div>
</template>

<script>
import finder from '../mock/finder.json'

export default {
  name: 'suiyue',
  data () {
    return {
      finder,
      items: [],
      index: null
    }
  },
  computed: {
    product () {
      let product = this.finder.finder_product.filter(item => item.categoryid === '4').reverse() || []
      let l = []
      product.map(item => {
        l.push({
          title: item.title,
          src: item.big_pic
        })
      })
      this.items = l
      return product
    }
  }
}
</script>
